


if(window.location.port == ""){
	dojo.registerModulePath("wc", window.location.protocol + "//" + window.location.hostname+ "/wcsstore/dojo18/wc");
}else{
	dojo.registerModulePath("wc", window.location.protocol + "//" + window.location.hostname+":"+window.location.port + "/wcsstore/dojo18/wc");
}


dojo.require("wc.service.common");
dojo.require("dojo.number");
dojo.require("dojo.has");
dojo.require("dojox.xml.DomParser");
dojo.require("wc.render.common");
dojo.require("dojox.collections.ArrayList");
dojo.require("wc.widget.Tooltip");
dojo.require("wc.widget.ScrollablePane");


dojo.require("dojo.io.iframe");
dojo.require("dojo.io.script");

dojo.require("dojo.parser");

dojo.require("dijit.form.Button");
dojo.require("wc.widget.WCMenu");
dojo.require("wc.widget.WCDialog");
dojo.require("dijit.layout.TabContainer");
dojo.require("dijit.layout.ContentPane");	
dojo.require("dijit.Tooltip");
dojo.require("wc.widget.WCDropDownButton");
dojo.require("dijit.Dialog");
dojo.require("dojo.currency");
dojo.require("dijit.Tree");
dojo.require("dojo.back");
dojo.require("dijit.form.DateTextBox");
dojo.require("wc.widget.RefreshArea");
dojo.require("wc.render.RefreshController");
dojo.require("wc.render.Context");
dojo.require("dojo.cookie");
dojo.require("dojo.topic");


var showDropdown = false;

var dropDownDlg = null;

var productAddedDropDownDlg = null;

var originalMiniCartWidth = 0;

var isIE = (document.all) ? true : false;

	var correctBrowser = false;

var requestSubmitted = true;

var currentId = "";

var numAjaxRequests = 0;

var widgetsList = [];

var tabPressed = false;

var currentPopup = '';

var android = null;

var ios = null;

function byId(r){
	return document.getElementById(r);
}

function destroyDialog(contentId){
	if(contentId == undefined){
		contentId = 'quick_cart_container';
	} 
	dojo.query('.dijitDialog', document).forEach(function(tag) {
		if (dijit.byNode(tag).id == contentId) 
			dijit.byNode(tag).destroyRecursive();
	 });

	 	if(contentId != undefined && contentId == 'quick_cart_container'){
	 	 dropDownDlg = null;
	} else {
		productAddedDropDownDlg = null;
	}
}

function hideUnderlayWrapper(){
	dojo.query('.dijitDialogUnderlayWrapper', document).forEach(function(tag) {		
		tag.style.display='none';
	});	
}

function loadLink(url){
	document.location.href=url;
}
var cursorDisplayTimeout = null;

function cursor_wait(checkForOpera) {
	var showPopup = true;	

	if(checkForOpera == true){
		if(dojo.isOpera > 0){
			showPopup = false;
		}
	}

	if(showPopup && !cursorDisplayTimeout){
		cursorDisplayTimeout = setTimeout('showProgressBar()',500);
	}
}

function showProgressBar(){

		displayProgressBar();

	}


function displayProgressBar(){


			var loader = document.getElementById('petco-loader'),
		bgScreen = document.getElementById('loader-screen');

		if(loader != null){
		loader.style.display = 'block';
	}
	if(bgScreen != null){
		bgScreen.style.display = 'block';
	}

			setTimeout("cursor_clear()",30000);

	}
function displayProgressBarForOrderProcess(checkForOpera){
	showPopup = true;
	if(checkForOpera == true){
		if(dojo.isOpera > 0){
			showPopup = false;
		}
	}
	var loader = document.getElementById('petco-loader'),
	bgScreen = document.getElementById('loader-screen');

	if(showPopup && loader != null){
		loader.style.display = 'block';
		if(bgScreen != null){
			bgScreen.style.display = 'block';
		}
	}

	}
function setCurrentId(id){
	if(!requestSubmitted && this.currentId == ""){
		this.currentId = id;
	}
}

function trim(inword)
{
	word = inword.toString();
	var i=0;
	var j=word.length-1;
	while(word.charAt(i) == " ") i++;
	while(word.charAt(j) == " ") j=j-1;
	if (i > j) {
		return word.substring(i,i);
	} else {
		return word.substring(i,j+1);
	}
}

function cursor_clear() {
		if (cursorDisplayTimeout) {
			clearTimeout(cursorDisplayTimeout);
			cursorDisplayTimeout = null;
		}
		requestSubmitted = false;



				var loader = document.getElementById('petco-loader'),
			bgScreen = document.getElementById('loader-screen');

				if(loader != null){
			loader.style.display = 'none';
		}
		if(bgScreen != null){
			bgScreen.style.display = 'none';
		}
}	

function submitRequest() {
	if(!requestSubmitted) {
		requestSubmitted  = true;
		return true;
	}
	return false;
}

function resetRequest() {
	requestSubmitted = false;
}

function setPageLocation(newPageLink) {

	if(document.getElementById("freeItemCheck")!= undefined && document.getElementById("freeItemCheck") != null && document.getElementById("freeItemCheck").value == 1)
	{
		newPageLink = newPageLink + '&freeItemId='+document.getElementById("freeItemId").value;

			}

		if(!submitRequest()){
		return;
	}
	document.location.href = newPageLink;
}

function checkForFreeItem(calculateOrderValue)
{
	document.getElementById("freeItemCheck").value = calculateOrderValue;
}

function submitSpecifiedForm(form) {
	if(!submitRequest()){
		return;
	}
	console.debug("form.action == "+form.action);
	form.submit();
}


function parseWidget(id)
{
}

function parseAllWidgets(){
	for(var i = 0; i < widgetsList.length; i++){
		parseWidget(widgetsList[i]);
	}
}

function addToWidgetsList(widgetId){
	widgetsList.push(widgetId);
}

  function hideElementById(elementId){
		var div = dojo.byId(elementId);
		div.style.display = "none";
 }


   function showElementById(elementId){
		var div = dojo.byId(elementId);
		div.style.display = "block";
}

    function hideBackgroundImage(element){
		element.style.backgroundImage='none';
}


	 function showBackgroundImage(element){
		element.style.backgroundImage='url('+getImageDirectoryPath()+getStyleDirectoryPath()+'product_hover_background.png)';
}

		function checkIE8Browser() { 
       if( dojo.isIE && dojo.isIE <= 8 ){
    	    correctBrowser = true
       }
   } 
function isNonNegativeInteger(value){
	var regExpTester = new RegExp(/^\d*$/);
	return (value != null && value != "" && regExpTester.test(value));
}

function isPositiveInteger(value){
	return (isNonNegativeInteger(value) && value != 0);
}

function closeAllDialogs(){
	dijit.registry.byClass("dijit.Dialog").forEach(function(w){w.hide()});
}

function setWarningMessageCookie(errorKey) {
	dojo.cookie("signon_warning_cookie",errorKey, {path: "/"});
}
function removeCookie(name) {
	dojo.cookie(name, null, {expires: -1});
}
function getCookie(c) {
	var cookies = document.cookie.split(";");
	for (var i = 0; i < cookies.length; i++) {
		var index = cookies[i].indexOf("=");
		var name = cookies[i].substr(0,index);
		name = name.replace(/^\s+|\s+$/g,"");
		if (name == c) {
			return unescape(cookies[i].substr(index + 1));
		}
	}
}

function setCookie(name, value,domain) {
    var cookie = name + "=" + encodeURIComponent(value)+";path=/";

        if(typeof domain === "string") {
		cookie += '; domain='+domain;		
        document.cookie = cookie;
    }else{
		document.cookie = cookie;
	}

	}


function setRememberMeStatus(){
	var isRemembered = document.forms["Logon"].rememberMe;
	if(null!==isRemembered){
		if(isRemembered.checked){
			dojo.cookie("rememberMe","true", {expires: 4});
		}else{
			removeCookie("rememberMe");
		}
	}
}


function isStorePreview(contextPathUsed,criteria) {
	if(contextPathUsed.indexOf(criteria)>-1) {
		return true;
	}
	return false;
}

function hideESpotInfoPopup(id,event) { 
	if(event!=null && event.type=="keypress" && event.keyCode!="27") {
		return;
	}
	else {
		var quickInfo = dijit.byId(id);
		if(quickInfo != null) {
			quickInfo.hide();
		}
	}
}

function showESpotInfoPopup(id,event) { 
	if(event!=null && event.type=="keypress" && event.keyCode!="13") {
		return;
	}
	else {
		if(!parent.checkPopupAllowed()){
			return;
		}
		var quickInfo = dijit.byId(id);
		if(quickInfo != null) {
			quickInfo.show();
		}
	}
}  
function incrementNumAjaxRequest() {
	if(numAjaxRequests != 'undefined'){
		numAjaxRequests++;
	}
}

function decrementNumAjaxRequest() {
	if(numAjaxRequests != 'undefined'){
		if(numAjaxRequests != 0){
			numAjaxRequests--;
		}
	}
}
dojo.subscribe("ajaxRequestInitiated",incrementNumAjaxRequest);
dojo.subscribe("ajaxRequestCompleted", decrementNumAjaxRequest);
function updateParamObject(params, key, value, toArray, index){

		if(params == null) {
		params = [];
	}
	if(params[key] != null && toArray) {
		if(dojo.lang.isArrayLike(params[key])) {
			if(index != null && index != "") {
				params[key][index] = value;
			} else {
				params[key].push(value);
			}
		} else {
			var tmpValue = params[key];
			params[key] = [];
			params[key].push(tmpValue);
			params[key].push(value);
		}
   } else {
	   if(index != null && index != "" && index != -1) {
		   params[key+"_"+index] = value;
	   } else if(index == -1) {
		   var i = 1;
		   while(params[key + "_" + i] != null) {
			   i++;
		   }
		   params[key + "_" + i] = value;
	   } else {
		   params[key] = value;
	   }
   }
   return params;
 }

function showSection (id){
	var section = dojo.byId(id);
	if(section!=null && section!='undefined'){
		section.style.visibility="visible";
	}
}

function hideSection (id){
	var section = dojo.byId(id);
	if(section!=null && section!='undefined'){
		section.style.visibility="";
	}
}

function shiftTabHideSection (id, event){
	if (event.shiftKey && (event.keyCode == dojo.keys.TAB)){
		hideSection(id);
	} 
}

function tabHideSection (id, event, nextId){
	if (!event.shiftKey && (event.keyCode == dojo.keys.TAB)){
		if(null != nextId){
			dojo.byId(nextId).focus();
		}
		hideSection(id);
		dojo.stopEvent(event);
	} 
}

function saveShiftTabPress(event) {
	if (event.shiftKey == true && event.keyCode == 9) {
		tabPressed = true;
	}
}

function saveTabPress(event) {
	if (event.shiftKey == false && event.keyCode == 9) {
		tabPressed = true;
	}
}
function setFocus(formElementId) {
	if (tabPressed) {
		tabPressed = false;
		document.getElementById(formElementId).focus();
	}
}

function increaseHeight(containerId, increase) {
	var temp = document.getElementById(containerId).offsetHeight;
	document.getElementById(containerId).style.height = (temp + increase) + 'px';
}


function redirectToSignOn(forcedUrl) {
	if(typeof(forcedUrl)!='undefined'){
		var currentURL = forcedUrl;
	}else{
		var currentURL = location.href;
	}
	currentURL = "OrderItemMove?continue=1&createIfEmpty=1&updatePrices=0&deleteIfEmpty=*&fromOrderId=*&toOrderId=.&page=&calculationUsageId=-1&URL="+encodeURIComponent("OrderCalculate?URL="+encodeURIComponent(currentURL));
	document.location.href = "LogonForm?myAcctMain=1&storeId="
			+ WCParamJS.storeId + "&catalogId=" + WCParamJS.catalogId
			+ "&langId=" + WCParamJS.langId + "&URL=" + encodeURIComponent(currentURL);
}

function handlePopup(link,newPopup) {
	if (currentPopup == newPopup){
		document.location.href = link;
	} else {
		currentPopup = newPopup;
	}
}

function isAndroid() {
	if(android == null){
		if(navigator != null){
			if(navigator.userAgent != null){
				var ua = navigator.userAgent.toLowerCase();
				android = ua.indexOf("android") > -1; 
			}
		}
	}
	return android;
}

function isIOS() {
	if(ios == null){
		if(navigator != null){
			if(navigator.userAgent != null){
				var ua = navigator.userAgent.toLowerCase();
				ios = (ua.indexOf("ipad") > -1) || (ua.indexOf("iphone") > -1) || (ua.indexOf("ipod") > -1); 
			}
		}
	}
	return ios;
}


function hideSpots(){
	dojo.removeClass(document.body,'editMode');
	dojo.query('.carousel > .content').style({zIndex:''});
	dojo.query(".ESpotInfo").style({ display:"none" });
	dojo.query(".caption").style({ display:"none" });
	dojo.query(".searchScore").style({ display:"none" });
	dojo.query(".editManagedContent").style({ display:"none" });
	dojo.query(".borderCaption").style({ display:"none" });
	dojo.query(".emptyESpot").forEach(function(e){
		dojo.style(e,{'width':dojo.attr(e,'_width')+'px'});
		dojo.style(e,{'height':dojo.attr(e,'_height')+'px'});
		});

	}

function logout(url){

	var dbAuthEnabledFlag = 'false';
	if(document.getElementById('dbAuthEnabledFlag') != null && document.getElementById('dbAuthEnabledFlag') != 'undefined'){
		dbAuthEnabledFlag = document.getElementById('dbAuthEnabledFlag').value;
	}
	if(dbAuthEnabledFlag == 'false') {
		var isamSignoutImg = document.createElement("img");     
		isamSignoutImg.src = document.getElementById('isamLogOffURL').value;
		document.body.appendChild(isamSignoutImg);
	}

		setDeleteCartCookie();
	var domain = "";
	if(dojo.byId('cookieDomain') != null){
		domain = dojo.byId('cookieDomain').value;
	}
	if(checkDeleteCartCookie()){
		var orderIdCookie = getCookie("WC_CartOrderId_"+WCParamJS.storeId);
				if(orderIdCookie != null){
					dojo.cookie("WC_CartOrderId_"+WCParamJS.storeId, null, {expires:-1,path:'/'});
					var cartTotalCookie = getCookie("WC_CartTotal_"+orderIdCookie);
					if(cartTotalCookie != null){
						dojo.cookie("WC_CartTotal_"+orderIdCookie, null, {expires:-1,path:'/'});
					}
					var cartRTotalCookie = getCookie("rCartTotal");
					if(cartRTotalCookie != null){
						dojo.cookie("rCartTotal", null, {expires:-1,path:'/',domain:domain});
					}
				}
	}
	if(getCookie("rememberMe")!= null){
		removeCookie("rememberMe");
		dojo.cookie("pfirstname", null, {expires:-1,path:'/'});
	}
	var domainName = window.location.hostname;
	dojo.cookie("pfirstname", null, {expires:-1,path:'/',domain:domainName});
	dojo.cookie("ptealiumData", null, {expires:-1,path:'/',domain:domainName});
	dojo.cookie("pcustData", null, {expires:-1,path:'/',domain:domainName});
	dojo.cookie("rfirstName", null, {expires:-1,path:'/',domain:domain});
	dojo.cookie("GetMember_cookie", null, {expires:-1,path:'/',domain:domain});
	dojo.cookie("GetMemberPals_cookie", null, {expires:-1,path:'/',domain:domain});
	dojo.cookie("PGRSession_Cookie", null, {expires:-1,path:'/',domain:domain});
	window.localStorage.removeItem('persist:nextjs');
	if(null !== sessionStorage.getItem('PALS_REWARDS_DATA')){
		sessionStorage.removeItem('PALS_REWARDS_DATA'); 				
	}
	if(dbAuthEnabledFlag == 'false') {
		setTimeout(function(){document.location.href = url;}, 500);
	} else {
		document.location.href = url;
	}

		}

function sitePromotionTag(promoName,promoLocation,flag) {
	 var promoDesc = "";
	 if (document.getElementById('tel_page_type') && flag ){
		 if (document.getElementById('tel_product_sku') && document.getElementById('productPartNo')) {
		    promoDesc = "PDP";
		 } else if ("Category" == document.getElementById('tel_page_type').value) {
		 	promoDesc = "CategoryPage";
		 } else if ("Home" == document.getElementById('tel_page_type').value) {
		 	promoDesc = "HomePage";
		 } else if ("receipt" == document.getElementById('tel_page_type').value) {
		 	promoDesc = "Order Confirmation";
		 } else if ("Search" == document.getElementById('tel_page_type').value) {
			promoDesc = "Search";
		 } else if ("account" == document.getElementById('tel_page_type').value) {
			promoDesc = "MyAccount";
		 } else if ("ShoppingCart" == document.getElementById('tel_page_type').value) {
			promoDesc = "ShoppingCart";
		 } else if ("SubCategory" == document.getElementById('tel_page_type').value || "Search" == document.getElementById('tel_page_type').value) {
			promoDesc = "Product List Browse & Search";
		 } else {
		 	promoDesc = "HomePage";
		 }
	 } else if (document.getElementById('tel_page_type')){

		 		 var pageType = document.getElementById('tel_page_type').value;
		 var PageCategory = document.getElementById('tel_page_category').value;
		 var pageSubCategory = document.getElementById('tel_page_subcategory').value;
		 var deptpage ="";
		 if (document.getElementById('dept_page'))
		     deptpage = document.getElementById('dept_page').value;
		 if (document.getElementById('tel_product_pet_type')) {
			 var childSubCategory = document.getElementById('tel_product_pet_type').value;
			 var temp = new Array();
			 if (childSubCategory.indexOf(":") != -1){
				 temp = childSubCategory.split(":");
				 childSubCategory = temp[temp.length-1];
			 }
		 }

		 		 if (document.getElementById('tel_product_sku')) {
		     promoDesc = childSubCategory+"PDP";
		 } else if ("Category" == pageType && deptpage == "true" ) {
			 promoDesc = PageCategory +""+ "Category";
		 } else if ("SubCategory" == pageType && deptpage == "true" ) {
		 	 promoDesc = pageSubCategory +""+ "Category";
		 } else if (("SubCategory" == pageType || "Search" == pageType)  && deptpage == '' ) {
			 if ("Search" == pageType){
				 promoDesc = PageCategory+"PL";
			 } else { 
				 promoDesc = pageSubCategory+"PL"; 
			 }
	     }
	 }
	 if (promoDesc == "") {
		 if (document.getElementById('WC_UserRegistrationAddForm_FormInput_page_In_Register_1'))
			   promoDesc = "Registration";
		 if (document.getElementById('WC_AccountDisplay_FormInput_ActivePage_In_Logon_1'))
			   promoDesc = "Sign In";		 
	 }
	 var promoJSON = {"event_name" : "promo_link_click","promo_name" : promoName, "promo_location" : promoLocation, "promo_desccrption" : promoDesc};

	}
dojo.addOnLoad(function() {
	 activateRatings();
    var innerhtm = "<a href='#topcontent' class='back-to-top' id='scrollToTop'><span class='glyphicon glyphicon-chevron-up'></span><p>top</p></a>"
    var str = document.location.href;
    if (!(str.includes("OrderItemDisplay")) &&  document.getElementById("scroolTop") != null) {
        document.getElementById("scroolTop").innerHTML = innerhtm;
        document.getElementById("scrollToTop").style.visibility = "hidden";
    }

        dojo.connect(dojo.byId('scrollToTop'), 'click', function(event) {
        event.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

        dojo.query('.collapse').on('hidden.bs.collapse', function() {
    	dojo.query(".glyphicon-minus", this.parentNode).removeClass("glyphicon-minus").addClass("glyphicon-plus");
	});

        dojo.query('.collapse').on('shown.bs.collapse', function() {
    	dojo.query(".glyphicon-plus", this.parentNode).removeClass("glyphicon-plus").addClass("glyphicon-minus");
	});

});
dojo.connect(window, 'onscroll', this, function(event) {
	if(document.getElementById("scrollToTop") != null){
		if (window.scrollY >= 350) {
			document.getElementById("scrollToTop").style.visibility = "visible";
			dojo.fadeIn({node: "scrollToTop"}).play();
	    } else {
	    	dojo.fadeOut({node: "scrollToTop"}).play();
	    	document.getElementById("scrollToTop").style.visibility = "hidden";
	    }
	}

	});
function scrollToTop(scrollDuration) {
    var scrollStep = -window.scrollY / (scrollDuration / 15),
        scrollInterval = setInterval(function(){
        if ( window.scrollY != 0 ) {
            window.scrollBy( 0, scrollStep );
        }
        else clearInterval(scrollInterval); 
    },15);
}
function cmManuallyTriggerEventTrack(element) {
	try{
		var cmValue = "";
		if(dojo.attr(element, "manual_cm_sp")) {
			cmValue = dojo.attr(element, "manual_cm_sp");
		}else if(dojo.attr(element, "manual_cm_re")) {
			cmValue = dojo.attr(element, "manual_cm_re");
		}
		if(typeof(cmCreateElementTag) == 'function' && cmValue != ""){
			var entryArray = cmValue.split("-_-");
			var entry1 = null, entry2 = null, entry3 = null;
			if (entryArray.length > 0) entry1 = entryArray[0];
			if (entryArray.length > 1) entry2 = entryArray[1];
			if (entryArray.length > 2) entry3 = entryArray.slice(2).join('-_-');
			cmCreateElementTag(entry2, entry1, entry3);
		}
	}catch(err){
		console.log("Error occurred in cmManuallyTriggerEventTrack(). "+ err);
		return true;
	}

	}

function appendCurrentPageUrl(element) {
	var currentUrl = window.location.href;
	var elementUrl = element.getAttribute('href');
	if (!elementUrl) return;
	if(currentUrl.indexOf('TopCategories') == -1 && currentUrl.indexOf('CSR') == -1 && currentUrl.indexOf('LogonForm') == -1) {
		element.setAttribute('href', elementUrl + '&URL=' + currentUrl);
	}
}

  function fnTriggerClickOnEnter(event){
    var elementToClick = $(event.target).data('element-to-click'),
    	keycode = event.keyCode ? event.keyCode : event.which;
	if(keycode === 13 || keycode === 32){
		$("#" + elementToClick).trigger('click');
	}
}
function applyCouponPromotion(){
	var promoName =  document.getElementById("promoName").value;
	var params = [];
  	params.storeId = '${storeId}';
	params.langId = '${langId}';
	params.catalogId = '${catalogId}';
	params.promotionName = promoName;
	if(document.getElementById("addOnSubscriptionId") != null){
		var addOnSubscriptionId =  document.getElementById("addOnSubscriptionId").value;
		var ffmtdate =  document.getElementById("ffmtdate").value;
		params.ffmtdate = ffmtdate;
		params.addOnSubscriptionId = addOnSubscriptionId;
		params.isRDAddOnCoupon = "true";		
	}
	params.URL = "CouponsDisplayView";
	wc.service.invoke('AjaxCouponIssue', params);
} 

function applyRealImageToImprovePerf(){
	$("img[imgSrcToLoad]").each(function(i,obj){
		var srcVal=$(obj).attr("imgSrcToLoad");
		if(typeof(srcVal) != "undefined"){
			obj.src=srcVal;
			$(obj).removeAttr("imgSrcToLoad");
		}
	})
	$("source[imgSrcToLoad]").each(function(i,obj){
		var srcVal=$(obj).attr("imgSrcToLoad");
		if(typeof(srcVal) != "undefined"){
			obj.srcset=srcVal;
			$(obj).removeAttr("imgSrcToLoad");
		}
	})
}

function applyRealImageToImprovePerfOnImgLoad(val){
if(applyRealImageToImprovePerf_loaded && val != null && val !=""){
		 var srcVal=$(val).attr("imgSrcToLoad");
		 if(typeof(srcVal) != "undefined"){
			val.src=srcVal;
			$(val).removeAttr("imgSrcToLoad");
		 }
		 $(val).parent("picture").find('source').each(function(i,obj){
				var srcVal=$(obj).attr("imgSrcToLoad");
				if(typeof(srcVal) != "undefined"){
					obj.srcset=srcVal;
					$(obj).removeAttr("imgSrcToLoad");
				}
		 });



		 						 }
}


function getForUserIdParam(doAmpersand, doEscape) {
	forUserIdParam = "";
	if(typeof wcCommonRequestParameters != 'undefined' &&
		wcCommonRequestParameters.forUserId != null
	) {
		if(doAmpersand && doEscape) {
			forUserIdParam="%26"; 
		} else if(doAmpersand) {
			forUserIdParam="&";
		}

				forUserIdParam = forUserIdParam + "forUserId";

				if(doEscape) {
			forUserIdParam = forUserIdParam + "%3D";
		} else {
			forUserIdParam = forUserIdParam + "=";
		}
		forUserIdParam = forUserIdParam + wcCommonRequestParameters.forUserId;
	}
	return forUserIdParam;
}	

function getAbsoluteURL() {
	if (absoluteURL != "") {
		var currentURL = document.URL;
		var currentProtocol = "";

			if (currentURL.indexOf("://") != -1) {
			currentProtocol = currentURL.substring(0, currentURL.indexOf("://"));
		}

				var savedProtocol = "";
		if (absoluteURL.indexOf("://") != -1) {
			savedProtocol = absoluteURL.substring(0, absoluteURL.indexOf("://"));
		}

				if (currentProtocol != savedProtocol) {
			absoluteURL = currentProtocol + absoluteURL.substring(absoluteURL.indexOf("://"));
		}
	}

		return absoluteURL;
}
function getImageDirectoryPath() {
	return imageDirectoryPath;
}
function getStyleDirectoryPath() {
	return styleDirectoryPath;
}
function appendWcCommonRequestParameters(url){
var paramter = "";
if(typeof(WCParamJS) != 'undefeined'){
	if(typeof(WCParamJS.catalogId) != 'undefeined' && typeof(WCParamJS.catalogId) != null){
		paramter=paramter+"catalogId="+WCParamJS.catalogId;
	}
	if(typeof(WCParamJS.storeId) != 'undefeined' && typeof(WCParamJS.storeId) != null){
		paramter=paramter+"&storeId="+WCParamJS.storeId;
	}
	if(typeof(WCParamJS.langId) != 'undefeined' && typeof(WCParamJS.langId) != null){
		paramter=paramter+"&langId="+WCParamJS.langId;
	}
	if(url.indexOf("?") == -1){
		url = url+"?"+paramter;
	}else{
		url = url+"&"+paramter;
	}
}
return url;
}

function pingPetcoUserType(){
	var d = new Date();
	var n = d.getTime();
	var thirtyminutes = 1800000;
	var vExpiryTime = n+thirtyminutes;
	var isNewEASession = getCookie("isNewEASession")?getCookie("isNewEASession"):"";	
	var isEASession = getCookie("isEASession")?getCookie("isEASession"):"";
	var isOBOSession = getCookie("isOBOSession")?getCookie("isOBOSession"):"";
	var isIgnorePetcoPingFromCookie = false;
	if( isNewEASession.toLowerCase() == 'yes' || isEASession.toLowerCase() == 'yes' || isOBOSession.toLowerCase() == 'yes'){
		isIgnorePetcoPingFromCookie = true;
	}
	if(isIgnorePetcoPingFromCookie){
		wc.service.invoke("pingPetcoUserTypeAction", parameters);
	}else{
		if(localStorage.getItem('pingPetcoUserType_Expiry') != null){
			var vActExpiryTime = localStorage.getItem('pingPetcoUserType_Expiry');
			if((vActExpiryTime*1) > n){
				var usertypeval = getCookie("WC_UserType")?getCookie("WC_UserType"):""; 
				var useridval =getCookie("WC_UserId")?getCookie("WC_UserId"):"";

							if(usertypeval != "" && useridval != ""){
					invokeCookieForLoginUser(usertypeval,useridval);
				}else{
					localStorage.setItem('pingPetcoUserType_Expiry', vExpiryTime);
					wc.service.invoke("pingPetcoUserTypeAction", parameters);
				}
			}else{
				localStorage.setItem('pingPetcoUserType_Expiry', vExpiryTime);
				wc.service.invoke("pingPetcoUserTypeAction", parameters);
			}
		}else{
			localStorage.setItem('pingPetcoUserType_Expiry', vExpiryTime);
			wc.service.invoke("pingPetcoUserTypeAction", parameters);
		}
	}
}


function activateRatings(){

		$.each($('input[id^="star_input_"]'),function(i,obj){
		var rating_cat_id=obj.id.replace("star_input_","");
			  var rating_input = parseFloat($(obj).val());
		  var num_stars = 5;
		  if(!isNaN(rating_input)) {
					  var percent = Math.round(rating_input*100/num_stars);
			  if(percent > 100) percent = 100;
			  $.each($("#star_limiter_"+rating_cat_id+" .longbar"),
				function(j,jobj){

				 				  jobj.style.maxWidth=percent+"%";

				  			  	}	  
			  )
			 }

		})

	}

var googleToggle='';
if($("#googleToggle").length>0){
     googleToggle = $("#googleToggle").val();
}
var oneTapToggle='';
if($("#oneTapToggle").length>0){
	oneTapToggle = $("#oneTapToggle").val();
}

if(googleToggle=='ON' || oneTapToggle == 'ON')	{
function onGoogleSuccess (googleUser) {
	console.log("Google SSO Success");
    var id_token = googleUser.getAuthResponse().id_token;
    var auth2 = gapi.auth2.getAuthInstance();
    auth2.disconnect();
    processGoogleSignOn(id_token, false);
}

function onGoogleFailure(error) {
	console.log("Google SSO Failure");
    console.log(error);
}

function processGoogleSignOn(id_token, isGoogleOneTap){
	 if (id_token) {

		  		var params = [];
         params['gAuthToken'] = id_token;
         if(isGoogleOneTap){
        	 params['isGoogleOneTap']= isGoogleOneTap;
        	 params['currentURL']= $(location).attr('href');
			 if ($(location).attr('href').indexOf('/LogonForm') > 0 || $(location).attr('href').indexOf('/UserRegistrationForm') > 0) {
        		 params['viaSignInOrCreateAccountPage']= true;
        	 }
			 if(PetcoDataLayer && 
					 PetcoDataLayer.page &&
					 PetcoDataLayer.page.page_name_join &&
					 PetcoDataLayer.page.page_name_join == 'Home:Home Page'){
				 params['viaSignInOrCreateAccountPage']= true;
			 }

			          }
		 if(undefined!=$("#WC_AccountDisplay_FormInput_URL_In_Logon_1").val()){
        	 params['URL']= encodeURIComponent($("#WC_AccountDisplay_FormInput_URL_In_Logon_1").val());
         }else if(undefined!= $("#WC_AccountDisplay_FormInput_URL_In_Logon_2").val()){
        	 params['URL']= encodeURIComponent($("#WC_AccountDisplay_FormInput_URL_In_Logon_2").val());
         }else if(undefined!= $("#WC_AccountDisplay_FormInput_URL_In_Logon_3").val()){
        	 params['URL']= encodeURIComponent($("#WC_AccountDisplay_FormInput_URL_In_Logon_3").val());
         }else if(undefined != $("#WC_UserRegistrationAddForm_FormInput_POSTURL_In_Register_1").val()){
        	 params['URL']= encodeURIComponent($("#WC_UserRegistrationAddForm_FormInput_POSTURL_In_Register_1").val());
         }

		 		 if($("#fromPage").length > 0){
			 params['fromPage']= $("#fromPage").val();
			 if($("#adobeDataLayerEnabled").length > 0 && 'true' == $("#adobeDataLayerEnabled").val()){
				 buildAdobeUserCheckoutLoginJSON('','','click-initial');
			 }
		 }else{
			 if($("#adobeDataLayerEnabled").length > 0 && 'true' == $("#adobeDataLayerEnabled").val()){
				 buildAdobeUserLoginJSON('','','click-initial');
			 }
		 }

		 params['rememberMe']= "true";

                  wc.service.invoke('AjaxPetcoGoogleSignonRegistration', params);
 } else {
     console.log("token is empty");
 }	
}

function handleCredentialResponse(response) {
	   processGoogleSignOn(response.credential, true);
}

   function renderGoogleButton() {
    gapi.signin2.render('petco-google-signin', {
        'scope' : 'profile email',
        'width' : 240,
        'height' : 50,
        'longtitle' : true,
        'theme' : 'light',
        'onsuccess' : onGoogleSuccess,
        'onfailure' : onGoogleFailure
    });
    setTimeout(function() {
                var buttonText = $('.button-text').data('button-name');
                $('.continue-google .abcRioButtonContents span').html(buttonText);
            }, 500);
}

function googleInit() {
	var loginButton = document.getElementById('petco-google-signin');
	if (loginButton) {
	    if (thirdPartyCookieDisabled) {
	      console.log('third Party Cookie Disabled');
	      var customGoogleSignInButton = '<button id="custom-google-sigin-button"></button>';
	      $('#petco-google-signin').html(customGoogleSignInButton);
	      loginButton.addEventListener("click", function(event) {
	    	  event.preventDefault();
	    	  alert("We're unable to open Google Sign-In. Please adjust your browser's privacy settings or use a different sign-in option.");    	  
	  	  });
	    } else {    
	    	gapi.load('auth2', function() {
	    	      var gauth  =  gapi.auth2.init();
	    	      gauth.attachClickHandler(loginButton, {}, onGoogleSuccess, onGoogleFailure);
	    	});    
	    	renderGoogleButton();
	    }
		loginButton.addEventListener("keyup", function(event) {
			    if (event.keyCode === 13) {
			    	loginButton.click();
			    }
		});
	} 
} 

function googleSignOut(url) {
	var auth2 = gapi.auth2.getAuthInstance();
	if (auth2) {
		auth2.signOut().then(function () {
			console.log('Google User signed out.');
			logout(url);
		});
	} else {
		logout(url);
	}
}
}

var appleSigninToggle='';
if($("#appleSigninToggle").length>0){
	appleSigninToggle = $("#appleSigninToggle").val();
}
if(googleToggle=='ON' && appleSigninToggle == 'ON')	{
	$("#WC_AccountDisplay_div_19").addClass("seperator-height");
}
if(googleToggle=='ON' || appleSigninToggle == 'ON')	{
	$("#WC_AccountDisplay_div_19").addClass("col-seperator-height");
}

if(appleSigninToggle == 'ON')	{
	document.addEventListener('AppleIDSignInOnSuccess', function(data)  {
	   console.log('success apple sign in authorization');
		  processAppleSignOn(data); 
	});
	document.addEventListener('AppleIDSignInOnFailure', function(error) {
		console.log('failure apple sign in authorization');
	});

		function processAppleSignOn(data){
		 if (data.detail.authorization) {
	 		var params = [];
	         params['appleAuthToken'] = data.detail.authorization.code;
	         if(data.detail.user){
	        	 params['email']= data.detail.user.email;
	        	 if(data.detail.user.name){
	        		 params['firstName']= data.detail.user.name.firstName; 
	        		 params['lastName']= data.detail.user.name.lastName;
	        	 }
	         }

	         	         if($("#fromPage").length > 0){
				 params['fromPage']= $("#fromPage").val();
				 if($("#adobeDataLayerEnabled").length > 0 && 'true' == $("#adobeDataLayerEnabled").val()){
					 buildAdobeUserCheckoutLoginJSON('','','click-initial');
				 }
			 }else{
				 if($("#adobeDataLayerEnabled").length > 0 && 'true' == $("#adobeDataLayerEnabled").val()){
					 buildAdobeUserLoginJSON('','','click-initial');
				 }
			 }

	         		if(undefined!=$("#WC_AccountDisplay_FormInput_URL_In_Logon_1").val()){
        	 params['URL']= encodeURIComponent($("#WC_AccountDisplay_FormInput_URL_In_Logon_1").val());
         }else if(undefined!= $("#WC_AccountDisplay_FormInput_URL_In_Logon_2").val()){
        	 params['URL']= encodeURIComponent($("#WC_AccountDisplay_FormInput_URL_In_Logon_2").val());
         }else if(undefined!= $("#WC_AccountDisplay_FormInput_URL_In_Logon_3").val()){
        	 params['URL']= encodeURIComponent($("#WC_AccountDisplay_FormInput_URL_In_Logon_3").val());
         }else if(undefined != $("#WC_UserRegistrationAddForm_FormInput_POSTURL_In_Register_1").val()){
        	 params['URL']= encodeURIComponent($("#WC_UserRegistrationAddForm_FormInput_POSTURL_In_Register_1").val());
         }	         
	         wc.service.invoke('AjaxPetcoAppleSignOn', params);
	 } else {
	     console.log("apple sign in data does not have authorisation details");
	 }	
	}
}


var thirdPartyCookieDisabled = false;
var bounceExchangeEventReceived = false;
var receiveMessage = function (evt) {
    console.log('receiveMessage', evt);
    if (evt.origin === 'https://assets.bounceexchange.com') {
      bounceExchangeEventReceived = true;
      console.log('bounceexchange', evt);
      if (evt.data === 'security_error') {
        console.log("Cookies had failed to be set; Blocked!!");
        thirdPartyCookieDisabled = true;
      } else {
    	thirdPartyCookieDisabled = false;
      }	      
    }
};

function callGoogleInit() {
	if (window.gapi) {
        googleInit();
     }
}

window.addEventListener("DOMContentLoaded", function() {
	var loginButton = document.getElementById('petco-google-signin');
	if (loginButton) {
		window.addEventListener("message", receiveMessage, false);		
		var postMessageCallcount = 20;
		var postMessageLoaded = setInterval(function () {
	    	if (bounceExchangeEventReceived) {
	    		console.log('bounceExchangeEventReceived in', postMessageCallcount);
	    		clearTimeout(postMessageLoaded);
	    		callGoogleInit();
	        }
			postMessageCallcount--;
		    if (postMessageCallcount === 0) {
		    	console.log('bounceExchangeEvent not received', postMessageCallcount);
		        clearTimeout(postMessageLoaded);	    	
		    	callGoogleInit();
		    }
		}, 500);
	}
}, false);

function displayProgressBarForRDPages(){
	var loader = document.getElementById('petco-loader'),
		bgScreen = document.getElementById('loader-screen');
	if(loader != null){
		loader.style.display = 'block';
	}
	if(bgScreen != null){
		bgScreen.style.display = 'block';
	}
	setTimeout("cursor_clear()",8000);
}

